// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".home-toolbar[data-v-43d4aa7c]{height:56px!important;width:100%}", ""]);
// Exports
module.exports = exports;
